import ES from './es';
import EN from './en';

const products = {
    ES,
    EN
};

export default products;
